import React, { useContext, useState } from "react";
import styled from "styled-components";
import Stat from "./Stat";
import { VizContext } from "../../contexts/VizContext";

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  font-size: 12px;
`;
const Row = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 1em;
  font-weight: 100;
  align-items: center;
`;
const Button = styled.div`
  padding: 0.5em;
  min-width: 50px;
  display: flex;
  background-color: ${(props) => (props.selected ? "#db0a41" : "#202731")};
  justify-content: center;
  align-items: center;
  height: 55%;
  border-radius: 4px;
  margin: 0.5em;
  box-sizing: border-box;
  :hover {
    background-color: #db0a41;
    cursor: pointer;
  }
`;

export default function TeamStats({ game }) {
  const { vizSharedMemory, vizCommand } = useContext(VizContext);
  const [selectedStat, setSelectedStat] = useState();
  function previewGraphic(name, options) {
    if (selectedStat === options.stat?.category) {
      setSelectedStat();
      vizCommand({
        viz_command:
          '10 GLOBAL*MAP SET_STRING_ELEMENT "SHMSend_ScoreComponents" Score|' +
          game?.home_team?.code +
          "|Score|" +
          game?.away_team?.code +
          "|1",
      });
    } else {
      setSelectedStat(options.stat?.category);
      vizCommand({
        viz_command:
          '10 GLOBAL*MAP SET_STRING_ELEMENT "SHMSend_ScoreComponents" Stat|' +
          (options.stat?.home || 0) +
          "|" +
          options.stat?.category +
          "|" +
          (options.stat?.away || 0) +
          "|1",
      });
    }
  }
  return (
    <Main>
      <Row>
        <Stat
          selected={selectedStat === "Goals"}
          game={game}
          category={"Goals"}
          matchStats={[]}
          stat={{
            home: game?.scores_by_quarter?.home?.goals,
            away: game?.scores_by_quarter?.away?.goals,
          }}
          previewGraphic={(name, options) => {
            previewGraphic(name, {
              ...options,
            });
          }}
        />
      </Row>
      <Row>
        <Stat
          selected={selectedStat === "Missed Shots"}
          game={game}
          category={"Missed Shots"}
          matchStats={[]}
          stat={{
            home: game?.home_player_stats?.reduce(
              (previous, item) =>
                (previous += parseInt(item.missed_shots) || 0),
              0,
            ),
            away: game?.away_player_stats?.reduce(
              (previous, item) =>
                (previous += parseInt(item.missed_shots) || 0),
              0,
            ),
          }}
          previewGraphic={(name, options) => {
            previewGraphic(name, {
              ...options,
            });
          }}
        />
      </Row>
      <Row>
        <Stat
          selected={selectedStat === "Penalties"}
          game={game}
          category={"Penalties"}
          matchStats={[]}
          stat={{
            home: game?.home_player_stats?.reduce(
              (previous, item) => (previous += parseInt(item.penalties) || 0),
              0,
            ),
            away: game?.away_player_stats?.reduce(
              (previous, item) => (previous += parseInt(item.penalties) || 0),
              0,
            ),
          }}
          previewGraphic={(name, options) => {
            previewGraphic(name, {
              ...options,
            });
          }}
        />
      </Row>
      <Row>
        <Stat
          selected={selectedStat === "Offensive rebounds"}
          game={game}
          category={"Offensive rebounds"}
          matchStats={[]}
          stat={{
            home: game?.home_player_stats?.reduce(
              (previous, item) =>
                (previous += parseInt(item.rebounds_offensive) || 0),
              0,
            ),
            away: game?.away_player_stats?.reduce(
              (previous, item) =>
                (previous += parseInt(item.rebounds_offensive) || 0),
              0,
            ),
          }}
          previewGraphic={(name, options) => {
            previewGraphic(name, {
              ...options,
            });
          }}
        />
      </Row>
      <Row>
        <Stat
          selected={selectedStat === "Defensive rebounds"}
          game={game}
          category={"Defensive rebounds"}
          matchStats={[]}
          stat={{
            home: game?.home_player_stats?.reduce(
              (previous, item) =>
                (previous += parseInt(item.rebounds_defensive) || 0),
              0,
            ),
            away: game?.away_player_stats?.reduce(
              (previous, item) =>
                (previous += parseInt(item.rebounds_defensive) || 0),
              0,
            ),
          }}
          previewGraphic={(name, options) => {
            previewGraphic(name, {
              ...options,
            });
          }}
        />
      </Row>
      <Row>
        <Stat
          selected={selectedStat === "Intercepts"}
          game={game}
          category={"Intercepts"}
          matchStats={[]}
          stat={{
            home: game?.home_player_stats?.reduce(
              (previous, item) => (previous += parseInt(item.intercepts) || 0),
              0,
            ),
            away: game?.away_player_stats?.reduce(
              (previous, item) => (previous += parseInt(item.intercepts) || 0),
              0,
            ),
          }}
          previewGraphic={(name, options) => {
            previewGraphic(name, {
              ...options,
            });
          }}
        />
      </Row>
      <Row>
        <Stat
          selected={selectedStat === "Deflections"}
          game={game}
          category={"Deflections"}
          matchStats={[]}
          stat={{
            home: game?.home_player_stats?.reduce(
              (previous, item) => (previous += parseInt(item.deflections) || 0),
              0,
            ),
            away: game?.away_player_stats?.reduce(
              (previous, item) => (previous += parseInt(item.deflections) || 0),
              0,
            ),
          }}
          previewGraphic={(name, options) => {
            previewGraphic(name, {
              ...options,
            });
          }}
        />
      </Row>
      <Row>
        <Stat
          selected={selectedStat === "Turnovers"}
          game={game}
          category={"Turnovers"}
          matchStats={[]}
          stat={{
            home: game?.home_player_stats?.reduce(
              (previous, item) => (previous += parseInt(item.turnovers) || 0),
              0,
            ),
            away: game?.away_player_stats?.reduce(
              (previous, item) => (previous += parseInt(item.turnovers) || 0),
              0,
            ),
          }}
          previewGraphic={(name, options) => {
            previewGraphic(name, {
              ...options,
            });
          }}
        />
      </Row>
      <Row>
        <Stat
          selected={selectedStat === "Unforced errors"}
          game={game}
          category={"Unforced errors"}
          matchStats={[]}
          stat={{
            home: game?.home_player_stats?.reduce(
              (previous, item) =>
                (previous += parseInt(item.unforced_errors) || 0),
              0,
            ),
            away: game?.away_player_stats?.reduce(
              (previous, item) =>
                (previous += parseInt(item.unforced_errors) || 0),
              0,
            ),
          }}
          previewGraphic={(name, options) => {
            previewGraphic(name, {
              ...options,
            });
          }}
        />
      </Row>
    </Main>
  );
}
